import _ from 'lodash'
import { IIBTokenProvider } from '@api/utils/IIBTokenProvider'
import { getSelectedTool } from '@atredux/selectors/toolSelector'
import { getSiteAssistModalState } from '@src/redux/selectors/siteAssistSelector'
import { store } from '@atredux/store'
import { UnsupportedActionException } from '@amzn/ihm-associate-tools-js-lib'
import { TokenRetrieverAllowedToolsList } from '@utils/Constants/TokenRetrieverAllowedToolsList'

export async function fetchIIBTokensIfAllowed () {
    const currentTool = getSelectedTool(store.getState())
    const isSiteAssistOpen = getSiteAssistModalState(store.getState())

    if (!TokenRetrieverAllowedToolsList || (!_.includes(TokenRetrieverAllowedToolsList, currentTool.toolName) && !isSiteAssistOpen)) {
        return Promise.reject(new UnsupportedActionException({
            message: 'Access Denied. The tool is not allowed to make this request.',
        }))
    }

    return fetchIIBTokens()
}

export async function fetchIIBTokens () {
    return Promise.resolve({
        tokenType: await IIBTokenProvider.getTokenType(),
        refreshToken: await IIBTokenProvider.getRefreshToken(),
        idToken: await IIBTokenProvider.getIdToken(),
        accessToken: await IIBTokenProvider.getAccessToken(),
        tokenExpiry: await IIBTokenProvider.getTokenExpiry(),
    })
}
